// removed by extract-text-webpack-plugin
module.exports = {"container":"WarningMessage__container___1Tq9R"};